import api from "../api.js";

/**
 * ID card service
 *
 * @package HOPS
 * @subpackage Cards
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class CardService {

	/**
	 * Approve ID cards.
	 *
	 * @param {Array<Integer>} Cards Card IDs to approve
	 * @return {Promise}
	 */
	static approveCards(Cards) {
		return api.call({
			url: `/api/cards/approve`,
			method: "POST",
			data: {Cards}
		});
	}


	/**
	 * Generate new ID cards.
	 * 
	 * @param {Array<Integer>} User IDs to generate for
	 * @param {Boolean} ExpiryDate optional YYYY-MM-DD
	 * @return {Promise}
	 */
	static generateCards(Users, ExpiryDate=null) {
		return api.call({
			url: `/api/cards/generate`,
			method: "POST",
			data: {Users, ExpiryDate}
		});
	}


	/**
	 * Query ID cards.
	 *
	 * @param {Object} params API query parameters
	 * @return {Promise} Resolves with API response data
	 */
	static query(params) {
		return api.call({url: `/api/cards`, params}).then(({data}) => data);
	}


	/**
	 * Query card information for the active organisation's users.
	 *
	 * @param {Object} params API query parameters
	 * @return {Promise} Resolves with API response data
	 */
	static queryUsers(params) {
		return api.call({url: `/api/cards/users`, params}).then(({data}) => data);
	}

}

export default CardService;
